"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meetingGetBulletinPdf = exports.meetingPdfScanCopy = exports.meetingBulletinAppeals = exports.meetingUnrecognizedDocumentsList = exports.unrecognizedFilesHistory = exports.meetingBulletinSingleFile = exports.meetingUnrecognizedDocumentFilters = exports.meetingHistory = exports.meetingsHistory = exports.meetingFilters = exports.meetingNotificationListSelectedUsersIds = exports.meetingNotificationFullStatistics = exports.meetingNotificationShortStatistics = exports.meetingNotificationFilters = exports.meetingBulletingHistory = exports.meetingAdminPanelHistory = exports.meetingProjectDecisionHistory = exports.meetingQuestionHistory = exports.meetingProjectDecisionReplies = exports.meetingProjectDecision = exports.meetingResultFilters = exports.meetingNotificationSelectedUsersIds = exports.meetingNotificationSelectedUsers = exports.meetingsList = exports.meetingBulletinRegistrationData = exports.meetingBulletinsFilters = exports.meetingBulletinsFooterStatistics = exports.meetingBulletinsResultList = exports.meetingBulletinsList = exports.meetingPublishingProtocolStatus = exports.meetingGeneratedProtocol = exports.meetingNotificationUsersList = exports.meetingTemplates = void 0;
var meetingTemplates_1 = require("./meetingTemplates");
Object.defineProperty(exports, "meetingTemplates", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingTemplates_1).default;
  }
});
var meetingNotificationUsersList_1 = require("./meetingNotificationUsersList");
Object.defineProperty(exports, "meetingNotificationUsersList", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingNotificationUsersList_1).default;
  }
});
var meetingGeneratedProtocol_1 = require("./meetingGeneratedProtocol");
Object.defineProperty(exports, "meetingGeneratedProtocol", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingGeneratedProtocol_1).default;
  }
});
var meetingPublishingProtocolStatus_1 = require("./meetingPublishingProtocolStatus");
Object.defineProperty(exports, "meetingPublishingProtocolStatus", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingPublishingProtocolStatus_1).default;
  }
});
var meetingBulletinsList_1 = require("./meetingBulletinsList");
Object.defineProperty(exports, "meetingBulletinsList", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinsList_1).default;
  }
});
var meetingBulletinsResultList_1 = require("./meetingBulletinsResultList");
Object.defineProperty(exports, "meetingBulletinsResultList", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinsResultList_1).default;
  }
});
var meetingBulletinsFooterStatistics_1 = require("./meetingBulletinsFooterStatistics");
Object.defineProperty(exports, "meetingBulletinsFooterStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinsFooterStatistics_1).default;
  }
});
var meetingBulletinsFilters_1 = require("./meetingBulletinsFilters");
Object.defineProperty(exports, "meetingBulletinsFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinsFilters_1).default;
  }
});
var meetingBulletinRegistrationData_1 = require("./meetingBulletinRegistrationData");
Object.defineProperty(exports, "meetingBulletinRegistrationData", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinRegistrationData_1).default;
  }
});
var meetingsList_1 = require("./meetingsList");
Object.defineProperty(exports, "meetingsList", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingsList_1).default;
  }
});
var meetingNotificationSelectedUsers_1 = require("./meetingNotificationSelectedUsers");
Object.defineProperty(exports, "meetingNotificationSelectedUsers", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingNotificationSelectedUsers_1).default;
  }
});
var meetingNotificationSelectedUsersIds_1 = require("./meetingNotificationSelectedUsersIds");
Object.defineProperty(exports, "meetingNotificationSelectedUsersIds", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingNotificationSelectedUsersIds_1).default;
  }
});
var meetingResultFilter_1 = require("./meetingResultFilter");
Object.defineProperty(exports, "meetingResultFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingResultFilter_1).default;
  }
});
var meetingProjectDecision_1 = require("./meetingProjectDecision");
Object.defineProperty(exports, "meetingProjectDecision", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingProjectDecision_1).default;
  }
});
var meetingProjectDecisionReplies_1 = require("./meetingProjectDecisionReplies");
Object.defineProperty(exports, "meetingProjectDecisionReplies", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingProjectDecisionReplies_1).default;
  }
});
var meetingQuestionHistory_1 = require("./meetingQuestionHistory");
Object.defineProperty(exports, "meetingQuestionHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingQuestionHistory_1).default;
  }
});
var meetingProjectDecisionHistory_1 = require("./meetingProjectDecisionHistory");
Object.defineProperty(exports, "meetingProjectDecisionHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingProjectDecisionHistory_1).default;
  }
});
var meetingBulletinsRegistrationHistory_1 = require("./meetingBulletinsRegistrationHistory");
Object.defineProperty(exports, "meetingAdminPanelHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinsRegistrationHistory_1).default;
  }
});
var meetingBulletinHistory_1 = require("./meetingBulletinHistory");
Object.defineProperty(exports, "meetingBulletingHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinHistory_1).default;
  }
});
var meetingNotificationFilters_1 = require("./meetingNotificationFilters");
Object.defineProperty(exports, "meetingNotificationFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingNotificationFilters_1).default;
  }
});
var meetingNotificationShortStatistics_1 = require("./meetingNotificationShortStatistics");
Object.defineProperty(exports, "meetingNotificationShortStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingNotificationShortStatistics_1).default;
  }
});
var meetingNotificationFullStatistics_1 = require("./meetingNotificationFullStatistics");
Object.defineProperty(exports, "meetingNotificationFullStatistics", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingNotificationFullStatistics_1).default;
  }
});
var meetingNotificationListSelectedUsersIds_1 = require("./meetingNotificationListSelectedUsersIds");
Object.defineProperty(exports, "meetingNotificationListSelectedUsersIds", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingNotificationListSelectedUsersIds_1).default;
  }
});
var meetingFilters_1 = require("./meetingFilters");
Object.defineProperty(exports, "meetingFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingFilters_1).default;
  }
});
var meetingsHistory_1 = require("./meetingsHistory");
Object.defineProperty(exports, "meetingsHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingsHistory_1).default;
  }
});
var meetingHistory_1 = require("./meetingHistory");
Object.defineProperty(exports, "meetingHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingHistory_1).default;
  }
});
var meetingUnrecognizedDocumentFilters_1 = require("./meetingUnrecognizedDocumentFilters");
Object.defineProperty(exports, "meetingUnrecognizedDocumentFilters", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingUnrecognizedDocumentFilters_1).default;
  }
});
var meetingBulletinSingleFile_1 = require("./meetingBulletinSingleFile");
Object.defineProperty(exports, "meetingBulletinSingleFile", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinSingleFile_1).default;
  }
});
var meetingUnrecognizedDocumentHistory_1 = require("./meetingUnrecognizedDocumentHistory");
Object.defineProperty(exports, "unrecognizedFilesHistory", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingUnrecognizedDocumentHistory_1).default;
  }
});
var meetingUnrecognizedDocumentsList_1 = require("./meetingUnrecognizedDocumentsList");
Object.defineProperty(exports, "meetingUnrecognizedDocumentsList", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingUnrecognizedDocumentsList_1).default;
  }
});
var meetingBulletinAppeals_1 = require("./meetingBulletinAppeals");
Object.defineProperty(exports, "meetingBulletinAppeals", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingBulletinAppeals_1).default;
  }
});
var meetingPdfScanCopy_1 = require("./meetingPdfScanCopy");
Object.defineProperty(exports, "meetingPdfScanCopy", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingPdfScanCopy_1).default;
  }
});
var meetingGetBulletinPdf_1 = require("./meetingGetBulletinPdf");
Object.defineProperty(exports, "meetingGetBulletinPdf", {
  enumerable: true,
  get: function () {
    return __importDefault(meetingGetBulletinPdf_1).default;
  }
});